import Matter from "matter-js";

function initSiteLoader() {
  if (document.querySelector(".site-loader")) return;
  const loader = document.createElement("div");
  loader.className = "site-loader";
  loader.setAttribute("aria-hidden", "true");
  loader.innerHTML = `
    <div class="site-loader-backdrop"></div>
    <div class="site-loader-spinner" aria-hidden="true"></div>
  `;
  document.body.appendChild(loader);
  document.body.classList.add("is-loading");

  const hide = () => {
    loader.classList.add("is-hidden");
    document.body.classList.remove("is-loading");
    const cleanup = () => loader.remove();
    loader.addEventListener("transitionend", cleanup, { once: true });
    setTimeout(cleanup, 700);
  };

  if (document.readyState === "complete") {
    hide();
  } else {
    window.addEventListener("load", hide, { once: true });
  }
}

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", initSiteLoader);
} else {
  initSiteLoader();
}

const backButtons = document.querySelectorAll(".js-back");
backButtons.forEach((button) => {
  button.addEventListener("click", () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = "page-draws.html";
  });
});

const headerActiveRules = [
  {
    selector: ".header-btn-home",
    match: [/^$/, /^index(\.html)?$/, /^main(\.html)?$/],
  },
  {
    selector: ".header-btn-projects",
    match: [/^page-projects(\.html)?$/, /^page-p-.*(\.html)?$/],
  },
  {
    selector: ".header-btn-draws",
    match: [/^page-draws(\.html)?$/, /^page-draw-\d+(\.html)?$/],
  },
  { selector: ".header-btn-about", match: [/^page-about(\.html)?$/] },
  { selector: ".header-btn-mod", match: [/^page-mm(\.html)?$/] },
  { selector: ".header-btn-s6", match: [/^page-s6(\.html)?$/] },
];

function applyHeaderActive() {
  const currentPath = window.location.pathname.split("/").pop() || "";
  const currentPage = currentPath.split("?")[0].split("#")[0];
  headerActiveRules.forEach(({ selector, match }) => {
    if (match.some((pattern) => pattern.test(currentPage))) {
      document.querySelectorAll(selector).forEach((button) => {
        button.classList.add("is-active");
      });
    }
  });
}

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", applyHeaderActive);
} else {
  applyHeaderActive();
}

function initAboutPostisch() {
  const postisch = document.querySelector(".page-about-postisch");
  const container = document.querySelector(".page-about-media-col");
  if (!postisch || !container) return;

  const state = {
    dragging: false,
    startX: 0,
    startY: 0,
    startLeft: 0,
    startTop: 0,
    lastSnap: "right",
  };

  function getBounds() {
    const containerRect = container.getBoundingClientRect();
    const imgRect = postisch.getBoundingClientRect();
    const maxLeft = Math.max(0, containerRect.width - imgRect.width);
    const maxTop = Math.max(0, containerRect.height - imgRect.height);
    return { containerRect, imgRect, maxLeft, maxTop };
  }

  function applySnap(side) {
    const { maxLeft } = getBounds();
    const leftOffset = -maxLeft * 0.02;
    const rightInset = -maxLeft * 0.02;
    const left = side === "left" ? leftOffset : maxLeft - rightInset;
    postisch.style.left = `${left}px`;
    postisch.style.right = "auto";
    postisch.style.setProperty("--postisch-scale", side === "left" ? -1 : 1);
    state.lastSnap = side;
  }

  // Initialize position based on current layout.
  const { containerRect, imgRect } = getBounds();
  const initialLeft = imgRect.left - containerRect.left;
  postisch.style.left = `${Math.max(0, initialLeft)}px`;
  postisch.style.right = "auto";
  state.lastSnap = initialLeft <= containerRect.width / 2 ? "left" : "right";
  applySnap(state.lastSnap);

  postisch.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    postisch.setPointerCapture(e.pointerId);
    state.dragging = true;
    state.startX = e.clientX;
    state.startY = e.clientY;
    state.startLeft = parseFloat(postisch.style.left) || 0;
    state.startTop = parseFloat(postisch.style.top) || 0;
    postisch.style.cursor = "grabbing";
  });

  postisch.addEventListener("pointermove", (e) => {
    if (!state.dragging) return;
    const { maxLeft, maxTop } = getBounds();
    const deltaX = e.clientX - state.startX;
    const deltaY = e.clientY - state.startY;
    const nextLeft = Math.min(maxLeft, Math.max(0, state.startLeft + deltaX));
    const nextTop = Math.min(maxTop, Math.max(0, state.startTop + deltaY));
    postisch.style.left = `${nextLeft}px`;
    postisch.style.top = `${nextTop}px`;
  });

  function endDrag(e) {
    if (!state.dragging) return;
    state.dragging = false;
    postisch.releasePointerCapture(e.pointerId);
    postisch.style.cursor = "grab";

    const { maxLeft } = getBounds();
    const currentLeft = parseFloat(postisch.style.left) || 0;
    const threshold = Math.min(80, maxLeft * 0.2);

    if (currentLeft <= threshold) {
      applySnap("left");
    } else if (maxLeft - currentLeft <= threshold) {
      applySnap("right");
    } else {
      applySnap(state.lastSnap);
    }
  }

  postisch.addEventListener("pointerup", endDrag);
  postisch.addEventListener("pointercancel", endDrag);

  window.addEventListener("resize", () => {
    applySnap(state.lastSnap);
  });
}

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", initAboutPostisch);
} else {
  initAboutPostisch();
}

const track = document.querySelector(".page-projects-articles");
const items = document.querySelectorAll(".page-projects-item");
const btnUp = document.querySelector(".page-projects-btn-arrow-top");
const btnDown = document.querySelector(".page-projects-btn-arrow-bottom");
const gallery = document.querySelector("#page-projects-gallery");

// 🛑 STOP si on n’est pas sur la page projects
if (!track || !items.length || !gallery) {
  // on quitte sans rien casser
} else {
  const itemHeight = 349 + 10;
  let index = 0;
  let isAnimating = false;

  function setupInfiniteScroll() {
    items.forEach((item) => {
      track.appendChild(item.cloneNode(true));
    });

    [...items].reverse().forEach((item) => {
      track.insertBefore(item.cloneNode(true), track.firstChild);
    });

    index = items.length;
    track.style.transition = "none";
    track.style.transform = `translateY(-${index * itemHeight}px)`;
  }

  function moveDown() {
    if (isAnimating) return;
    isAnimating = true;

    index++;
    track.style.transition = "transform 0.4s ease";
    track.style.transform = `translateY(-${index * itemHeight}px)`;

    setTimeout(() => {
      if (index >= items.length * 2) {
        track.style.transition = "none";
        index = items.length;
        track.style.transform = `translateY(-${index * itemHeight}px)`;
      }
      isAnimating = false;
    }, 400);
  }

  function moveUp() {
    if (isAnimating) return;
    isAnimating = true;

    index--;
    track.style.transition = "transform 0.4s ease";
    track.style.transform = `translateY(-${index * itemHeight}px)`;

    setTimeout(() => {
      if (index <= 0) {
        track.style.transition = "none";
        index = items.length;
        track.style.transform = `translateY(-${index * itemHeight}px)`;
      }
      isAnimating = false;
    }, 400);
  }

  setupInfiniteScroll();

  btnDown?.addEventListener("click", moveDown);
  btnUp?.addEventListener("click", moveUp);

  // 🎯 Scroll souris UNIQUEMENT sur la galerie
  gallery.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      e.deltaY > 0 ? moveDown() : moveUp();
    },
    { passive: false },
  );
}

// Carousel horizontal avec cartes empilées------------------------------------------
// 🎨 Super Carousel 3D Horizontal avec boucle infinie + Drag libre
const galleryDraw = document.querySelector("#page-draws-gallery");
const cards = document.querySelectorAll(".page-draws-item");
const btnLeft = document.querySelector(".page-draws-btn-left");
const btnRight = document.querySelector(".page-draws-btn-right");

if (!galleryDraw || !cards.length) {
  // Pas sur la page draws
} else {
  let currentIndex = 0;
  let isAnimating = false;
  const originalCards = Array.from(cards);
  const totalCards = originalCards.length;

  // Variables pour le drag
  let isDragging = false;
  let startX = 0;
  let currentOffset = 0;
  let dragOffset = 0;
  let dragMoved = false;
  let touchMoved = false;
  let touchStartTarget = null;
  const lastDrawKey = "draws:lastIndex";

  function normalizeIndex(index) {
    return ((index % totalCards) + totalCards) % totalCards;
  }

  // 🎯 Positionner les cartes
  function updateCarousel(instant = false, customOffset = 0) {
    originalCards.forEach((card, index) => {
      const center = currentIndex + customOffset;
      let offset = index - center;
      const half = totalCards / 2;

      if (offset > half) offset -= totalCards;
      if (offset < -half) offset += totalCards;

      const absOffset = Math.abs(offset);

      // Position horizontale
      const translateX = offset * 400;

      // Profondeur (perspective)
      const translateZ = -absOffset * 150;

      // Opacité
      const opacity = absOffset === 0 ? 1 : Math.max(0.3, 1 - absOffset * 0.05);

      // Scale
      const scale = absOffset === 0 ? 1.1 : Math.max(0.7, 1 - absOffset * 0.15);

      // Rotation
      const rotateY = offset * -15;

      // Application
      if (instant) {
        card.style.transition = "none";
      } else {
        card.style.transition = "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)";
      }

      card.style.transform = `
        translateX(${translateX}px) 
        translateZ(${translateZ}px) 
        scale(${scale})
        rotateY(${rotateY}deg)
      `;
      card.style.opacity = opacity;
      card.style.zIndex = 100 - absOffset;

      // Classe active sur la carte centrale
      if (Math.abs(offset) < 0.5) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    });
  }

  // 🎯 Snap à la carte la plus proche
  function snapToNearest() {
    const snapIndex = Math.round(currentIndex + dragOffset);
    currentIndex = normalizeIndex(snapIndex);
    dragOffset = 0;
    updateCarousel();
  }

  // ➡️ Aller à droite
  function goNext() {
    if (isAnimating || isDragging) return;
    isAnimating = true;

    currentIndex = normalizeIndex(currentIndex + 1);
    updateCarousel();

    setTimeout(() => {
      isAnimating = false;
    }, 600);
  }

  // ⬅️ Aller à gauche
  function goPrev() {
    if (isAnimating || isDragging) return;
    isAnimating = true;

    currentIndex = normalizeIndex(currentIndex - 1);
    updateCarousel();

    setTimeout(() => {
      isAnimating = false;
    }, 600);
  }

  // 🔘 Boutons de navigation
  if (btnLeft) {
    btnLeft.addEventListener("click", (e) => {
      e.preventDefault();
      goNext();
    });
  }

  if (btnRight) {
    btnRight.addEventListener("click", (e) => {
      e.preventDefault();
      goPrev();
    });
  }

  // Drag désactivé (navigation via boutons uniquement)

  galleryDraw.addEventListener("click", (e) => {
    if (isDragging || dragMoved) return;
    const card = e.target.closest(".page-draws-item");
    const drawId = card?.getAttribute("data-draw");
    if (drawId) {
      const drawIndex = Number(drawId.replace("draw-", "")) - 1;
      if (!Number.isNaN(drawIndex)) {
        sessionStorage.setItem(lastDrawKey, String(drawIndex));
      }
      window.location.href = `page-${drawId}.html`;
    }
  });

  // ⌨️ Clavier
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") goNext();
    if (e.key === "ArrowLeft") goPrev();
  });

  // 🎬 Init
  galleryDraw.style.cursor = "grab";
  const savedIndex = Number(sessionStorage.getItem(lastDrawKey));
  if (!Number.isNaN(savedIndex)) {
    currentIndex = normalizeIndex(savedIndex);
  }
  updateCarousel(true);
}

// ========================================
// STICKY CAROUSEL AVEC GRAVITÉ MATTER.JS
// ========================================

window.addEventListener("load", function () {
  const stickyElement = document.querySelector("#sticky");
  const stickyArticles = document.querySelector(".sticky-articles");
  const btnArrowTop = document.querySelector(".sticky-btn-arrow-top");
  const btnArrowBottom = document.querySelector(".sticky-btn-arrow-bottom");
  const filterToggleBtn = document.querySelector(".sticky-btn-filter");
  const filterContainer = document.querySelector(".filter-buttons-container");
  const stickyPhoneBtn = document.querySelector(".sticky-button-phone");
  const stickyPhoneIconClosed = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="26" viewBox="0 0 16 26" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2 -5.59506e-07L16 13L3.2 26L-4.07598e-08 22.75L9.6 13L8.11612e-07 3.25L3.2 -5.59506e-07Z" fill="white"/>
    </svg>
  `;
  const stickyPhoneIconOpen = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="26" viewBox="0 0 16 26" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8 26L1.55023e-07 13L12.8 1.52638e-07L16 3.25L6.4 13L16 22.75L12.8 26Z" fill="white"/>
    </svg>
  `;

  if (stickyPhoneBtn && stickyElement) {
    stickyPhoneBtn.addEventListener("click", () => {
      const isOpen = stickyElement.classList.toggle("is-open");
      stickyPhoneBtn.innerHTML = isOpen
        ? stickyPhoneIconOpen
        : stickyPhoneIconClosed;
    });
  }

  // Variables globales pour Matter.js
  let matterEngine = null;
  let matterRender = null;
  let matterRunner = null;
  let itemBodies = [];
  let itemElements = [];
  let mouseConstraint = null;
  let isGravityMode = false;
  let physicsCanvas = null;

  // Variables pour le scroll infini
  let isAdjusting = false;
  let currentFilter = "all";
  const itemHeight = 359;

  // ========================================
  // CONFIGURATION INITIALE DU CAROUSEL
  // ========================================
  if (stickyElement && stickyArticles) {
    const items = Array.from(document.querySelectorAll(".sticky-item"));

    // Clone TOUS les items et les ajoute à la fin ET au début
    items.forEach((item) => {
      const cloneEnd = item.cloneNode(true);
      cloneEnd.dataset.stickyClone = "true";
      stickyArticles.appendChild(cloneEnd);
    });

    items
      .slice()
      .reverse()
      .forEach((item) => {
        const cloneStart = item.cloneNode(true);
        cloneStart.dataset.stickyClone = "true";
        stickyArticles.insertBefore(cloneStart, stickyArticles.firstChild);
      });

    // Démarre au milieu (sur les items originaux)
    stickyArticles.scrollTop = items.length * itemHeight;

    // Gère le scroll infini
    stickyArticles.addEventListener("scroll", () => {
      if (isAdjusting || isGravityMode || currentFilter !== "all") return;

      const scrollTop = stickyArticles.scrollTop;
      const totalItems = items.length;

      // Si on arrive à la fin
      if (scrollTop >= totalItems * 2 * itemHeight) {
        isAdjusting = true;
        stickyArticles.scrollTop = totalItems * itemHeight;
        requestAnimationFrame(() => {
          isAdjusting = false;
        });
      }

      // Si on arrive au début
      if (scrollTop <= 0) {
        isAdjusting = true;
        stickyArticles.scrollTop = totalItems * itemHeight;
        requestAnimationFrame(() => {
          isAdjusting = false;
        });
      }
    });

    // Bouton pour monter
    if (btnArrowTop) {
      btnArrowTop.addEventListener("click", () => {
        if (!isGravityMode) {
          stickyArticles.scrollBy({
            top: -itemHeight,
            behavior: "smooth",
          });
        }
      });
    }

    // Bouton pour descendre
    if (btnArrowBottom) {
      btnArrowBottom.addEventListener("click", () => {
        if (!isGravityMode) {
          stickyArticles.scrollBy({
            top: itemHeight,
            behavior: "smooth",
          });
        }
      });
    }
  }

  // ========================================
  // MATTER.JS - SYSTÈME DE GRAVITÉ
  // ========================================
  function initGravityMode() {
    if (isGravityMode || !window.Matter) return;

    const {
      Engine,
      Render,
      Runner,
      World,
      Bodies,
      Mouse,
      MouseConstraint,
      Events,
    } = Matter;

    isGravityMode = true;

    // Désactiver le scroll
    stickyArticles.style.overflow = "hidden";

    // Créer le conteneur canvas
    physicsCanvas = document.createElement("div");
    physicsCanvas.id = "sticky-physics-canvas";
    physicsCanvas.style.position = "absolute";
    physicsCanvas.style.top = "0";
    physicsCanvas.style.left = "0";
    physicsCanvas.style.width = "100%";
    physicsCanvas.style.height = "360px";
    physicsCanvas.style.pointerEvents = "auto";
    physicsCanvas.style.cursor = "grab";
    physicsCanvas.style.zIndex = "10";

    stickyArticles.style.position = "relative";
    stickyArticles.insertBefore(physicsCanvas, stickyArticles.firstChild);

    // Créer le moteur physique
    matterEngine = Engine.create({
      gravity: { x: 0, y: 1 },
    });

    matterRender = Render.create({
      element: physicsCanvas,
      engine: matterEngine,
      options: {
        width: stickyArticles.offsetWidth,
        height: 360,
        wireframes: false,
        background: "transparent",
      },
    });

    // Récupérer tous les items visibles
    const visibleItems = Array.from(
      stickyArticles.querySelectorAll(".sticky-item:not(.hidden)"),
    );

    itemElements = [];
    itemBodies = [];

    // Créer les corps physiques pour chaque item visible
    visibleItems.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const parentRect = stickyArticles.getBoundingClientRect();

      // Position relative
      const x = rect.width / 2 + (index % 2) * 100;
      const y = -50 - index * 60; // Spawner au-dessus

      // Créer un corps rectangulaire
      const body = Bodies.rectangle(x, y, rect.width, rect.height, {
        restitution: 0.3,
        friction: 0.1,
        density: 0.002,
        render: {
          visible: false,
        },
      });

      World.add(matterEngine.world, body);
      itemBodies.push(body);
      itemElements.push(item);

      // Rendre l'item draggable
      item.style.pointerEvents = "none";
      item.style.position = "absolute";
      item.style.cursor = "grab";
    });

    // Créer les murs
    function createWalls() {
      const width = stickyArticles.offsetWidth;
      const height = 360;
      const thickness = 20;

      // Supprimer les anciens murs
      const oldWalls = matterEngine.world.bodies.filter(
        (body) => body.isStatic && body.label === "wall",
      );
      World.remove(matterEngine.world, oldWalls);

      // Sol
      const ground = Bodies.rectangle(
        width / 2,
        height + thickness / 2,
        width,
        thickness,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur gauche
      const leftWall = Bodies.rectangle(
        -thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur droit
      const rightWall = Bodies.rectangle(
        width + thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      World.add(matterEngine.world, [ground, leftWall, rightWall]);
    }

    createWalls();

    // Système de drag
    const mouse = Mouse.create(matterRender.canvas);
    mouseConstraint = MouseConstraint.create(matterEngine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
      },
    });

    World.add(matterEngine.world, mouseConstraint);
    matterRender.mouse = mouse;

    // Variables pour le système de lancer
    let lastMousePosition = { x: 0, y: 0 };
    let lastTime = Date.now();
    let velocityHistory = [];
    const velocityHistorySize = 8;
    let draggedItem = null;
    let mouseDownTime = 0;
    let mouseDownPosition = { x: 0, y: 0 };

    // Suivre la position de la souris
    Events.on(matterEngine, "beforeUpdate", function () {
      const currentTime = Date.now();
      const deltaTime = (currentTime - lastTime) / 1000;

      if (mouseConstraint.body && deltaTime > 0) {
        const currentMousePosition = mouse.position;

        const instantVelocity = {
          x: (currentMousePosition.x - lastMousePosition.x) / deltaTime,
          y: (currentMousePosition.y - lastMousePosition.y) / deltaTime,
          time: currentTime,
        };

        velocityHistory.push(instantVelocity);
        if (velocityHistory.length > velocityHistorySize) {
          velocityHistory.shift();
        }

        lastMousePosition = { ...currentMousePosition };
      } else if (!mouseConstraint.body) {
        velocityHistory = [];
        lastMousePosition = { ...mouse.position };
      }

      lastTime = currentTime;
    });

    // Changer le curseur pendant le drag
    Events.on(mouseConstraint, "startdrag", function (event) {
      physicsCanvas.style.cursor = "grabbing";
      velocityHistory = [];
      lastMousePosition = { ...mouse.position };
      lastTime = Date.now();
      mouseDownTime = Date.now();
      mouseDownPosition = { ...mouse.position };

      const draggedBodyIndex = itemBodies.indexOf(event.body);
      if (draggedBodyIndex !== -1) {
        draggedItem = itemElements[draggedBodyIndex];
        draggedItem.style.transition = "transform 0.1s ease";
        draggedItem.style.transform = `rotate(${event.body.angle}rad) scale(1.05)`;
      }
    });

    Events.on(mouseConstraint, "enddrag", function (event) {
      physicsCanvas.style.cursor = "grab";

      const dragDuration = Date.now() - mouseDownTime;
      const dragDistance = Math.sqrt(
        Math.pow(mouse.position.x - mouseDownPosition.x, 2) +
          Math.pow(mouse.position.y - mouseDownPosition.y, 2),
      );

      const isClick = dragDuration < 200 && dragDistance < 10;

      if (draggedItem) {
        draggedItem.style.transition = "none";

        // Si c'est un clic, déclencher l'action
        if (isClick) {
          const projectId = draggedItem.getAttribute("data-project");
          if (projectId) {
            switchProject(projectId);
          }
        }

        draggedItem = null;
      }

      // Appliquer la vélocité
      if (!isClick && velocityHistory.length > 0 && event.body) {
        const now = Date.now();
        const recentVelocities = velocityHistory.filter(
          (v) => now - v.time < 200,
        );

        if (recentVelocities.length > 0) {
          let totalWeight = 0;
          const weightedVelocity = recentVelocities.reduce(
            (acc, vel, index) => {
              const weight = index + 1;
              totalWeight += weight;
              return {
                x: acc.x + vel.x * weight,
                y: acc.y + vel.y * weight,
              };
            },
            { x: 0, y: 0 },
          );

          weightedVelocity.x /= totalWeight;
          weightedVelocity.y /= totalWeight;

          const throwMultiplier = 0.015;
          const maxThrowSpeed = 20;

          let finalVelocityX = weightedVelocity.x * throwMultiplier;
          let finalVelocityY = weightedVelocity.y * throwMultiplier;

          const speed = Math.sqrt(
            finalVelocityX * finalVelocityX + finalVelocityY * finalVelocityY,
          );
          if (speed > maxThrowSpeed) {
            const scale = maxThrowSpeed / speed;
            finalVelocityX *= scale;
            finalVelocityY *= scale;
          }

          Matter.Body.setVelocity(event.body, {
            x: finalVelocityX,
            y: finalVelocityY,
          });

          if (speed > 10) {
            const angularVelocity =
              (finalVelocityX / 1000) * (Math.random() > 0.5 ? 1 : -1);
            Matter.Body.setAngularVelocity(event.body, angularVelocity);
          }
        }
      }

      velocityHistory = [];
    });

    // Synchroniser les positions
    Events.on(matterEngine, "afterUpdate", function () {
      itemBodies.forEach((body, index) => {
        const item = itemElements[index];
        item.style.position = "absolute";
        item.style.left = `${body.position.x - item.offsetWidth / 2}px`;
        item.style.top = `${body.position.y - item.offsetHeight / 2}px`;
        item.style.transform = `rotate(${body.angle}rad)`;
      });
    });

    // Lancer le moteur
    matterRunner = Runner.create();
    Runner.run(matterRunner, matterEngine);
    Render.run(matterRender);

    // Gérer le redimensionnement
    window.addEventListener("resize", function () {
      const width = stickyArticles.offsetWidth;

      matterRender.canvas.width = width;
      matterRender.options.width = width;

      createWalls();
    });
  }

  function destroyGravityMode() {
    if (!isGravityMode) return;

    // Arrêter Matter.js
    if (matterRunner) {
      Matter.Runner.stop(matterRunner);
    }
    if (matterRender) {
      Matter.Render.stop(matterRender);
    }
    if (matterEngine) {
      Matter.World.clear(matterEngine.world);
      Matter.Engine.clear(matterEngine);
    }

    // Supprimer le canvas
    if (physicsCanvas) {
      physicsCanvas.remove();
    }

    // Réactiver le scroll
    stickyArticles.style.overflow = "";

    // Réinitialiser les items
    itemElements.forEach((item) => {
      item.style.position = "";
      item.style.left = "";
      item.style.top = "";
      item.style.transform = "";
      item.style.pointerEvents = "";
    });

    itemBodies = [];
    itemElements = [];
    isGravityMode = false;

    // Réinitialiser le scroll
    resetInfiniteScroll();
  }

  // ========================================
  // SYSTÈME DE FILTRAGE
  // ========================================

  // SVG fermé (entonnoir)
  const svgClosed = `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M14.5833 12V19.88C14.625 20.18 14.5208 20.5 14.2813 20.71C14.1849 20.8027 14.0704 20.8763 13.9444 20.9264C13.8184 20.9766 13.6833 21.0024 13.5469 21.0024C13.4105 21.0024 13.2754 20.9766 13.1494 20.9264C13.0234 20.8763 12.9089 20.8027 12.8125 20.71L10.7188 18.7C10.6052 18.5933 10.5189 18.4629 10.4665 18.319C10.4141 18.175 10.397 18.0213 10.4167 17.87V12H10.3854L4.38543 4.62C4.21627 4.41153 4.13995 4.14726 4.17313 3.88493C4.20631 3.6226 4.3463 3.38355 4.56251 3.22C4.76043 3.08 4.97918 3 5.20835 3H19.7917C20.0208 3 20.2396 3.08 20.4375 3.22C20.6537 3.38355 20.7937 3.6226 20.8269 3.88493C20.8601 4.14726 20.7838 4.41153 20.6146 4.62L14.6146 12H14.5833Z" fill="white"/>
</svg>
`;

  // SVG ouvert (X)
  const svgOpen = `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M4.82409 2.01542L12.5 9.38398L20.1361 2.0536C20.3048 1.88125 20.508 1.74338 20.7335 1.64825C20.9591 1.55313 21.2023 1.5027 21.4486 1.5C21.976 1.5 22.4818 1.70112 22.8547 2.05912C23.2277 2.41712 23.4372 2.90267 23.4372 3.40895C23.4418 3.643 23.3966 3.87548 23.3043 4.09213C23.2119 4.30879 23.0744 4.50505 22.9003 4.66886L15.1647 11.9992L22.9003 19.4251C23.228 19.7329 23.4202 20.1497 23.4372 20.5895C23.4372 21.0958 23.2277 21.5814 22.8547 21.9394C22.4818 22.2974 21.976 22.4985 21.4486 22.4985C21.1952 22.5086 20.9423 22.468 20.7061 22.3792C20.4699 22.2905 20.2555 22.1556 20.0765 21.9831L12.5 14.6145L4.84398 21.964C4.67595 22.1306 4.47522 22.2636 4.25337 22.3553C4.03152 22.4471 3.79294 22.4957 3.5514 22.4985C3.024 22.4985 2.5182 22.2974 2.14526 21.9394C1.77233 21.5814 1.56282 21.0958 1.56282 20.5895C1.55819 20.3555 1.60342 20.123 1.69575 19.9064C1.78808 19.6897 1.92555 19.4934 2.09974 19.3296L9.83531 11.9992L2.09974 4.57342C1.77199 4.26561 1.57981 3.8488 1.56282 3.40895C1.56282 2.90267 1.77233 2.41712 2.14526 2.05912C2.5182 1.70112 3.024 1.5 3.5514 1.5C4.02866 1.50573 4.48603 1.6909 4.82409 2.01542Z" fill="white"/>
</svg>
`;

  if (filterToggleBtn && filterContainer) {
    filterToggleBtn.addEventListener("click", () => {
      const isOpen = filterContainer.classList.toggle("active");
      filterToggleBtn.innerHTML = isOpen ? svgOpen : svgClosed;

      // Si on ouvre les filtres, activer le mode gravité
      if (isOpen) {
        initGravityMode();
      } else {
        destroyGravityMode();
      }
    });
  }

  // Sélection des boutons de filtre
  const filterButtons = document.querySelectorAll(".filter-btn");

  // Gestion du filtrage
  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const filter = button.getAttribute("data-filter");
      currentFilter = filter;

      // Met à jour l'état actif des boutons
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Désactiver le mode gravité avant de filtrer
      if (isGravityMode) {
        destroyGravityMode();
      }

      // Applique le filtre
      applyFilter(filter);

      // Réactiver le mode gravité après le filtrage
      setTimeout(() => {
        if (filterContainer.classList.contains("active")) {
          initGravityMode();
        }
      }, 400);
    });
  });

  // Fonction pour appliquer le filtre
  function applyFilter(filter) {
    const allItems = document.querySelectorAll(".sticky-item");

    allItems.forEach((item) => {
      // Reset inline styles qui pourraient interférer
      item.style.position = "";
      item.style.left = "";
      item.style.top = "";
      item.style.transform = "";
      item.style.pointerEvents = "";

      if (item.dataset.stickyClone === "true") {
        if (filter === "all") {
          item.classList.remove("hidden");
          item.style.opacity = "1";
        } else {
          item.style.opacity = "0";
          item.classList.add("hidden");
        }
        return;
      }

      if (filter === "all") {
        item.classList.remove("hidden");
        item.style.opacity = "1";
      } else {
        if (item.classList.contains(`project-${getColorClass(filter)}`)) {
          item.classList.remove("hidden");
          setTimeout(() => {
            item.style.opacity = "1";
          }, 10);
        } else {
          item.style.opacity = "0";
          setTimeout(() => {
            item.classList.add("hidden");
          }, 300);
        }
      }
    });

    setTimeout(() => {
      resetInfiniteScroll();
    }, 350);
  }

  // Mapping entre les filtres et les classes de couleur
  function getColorClass(filter) {
    const mapping = {
      photo: "purple",
      motion: "blue",
      marketing: "yellow",
      video: "green",
      graphic: "red",
      uu: "cyan",
      frontend: "pink",
    };
    return mapping[filter] || "";
  }

  // Fonction pour réinitialiser le scroll infini
  function resetInfiniteScroll() {
    if (!stickyArticles || isGravityMode) return;

    const visibleItems = Array.from(
      stickyArticles.querySelectorAll(
        '.sticky-item:not([data-sticky-clone="true"]):not(.hidden)',
      ),
    );

    if (visibleItems.length > 0) {
      const middleIndex = Math.floor(visibleItems.length / 3);
      stickyArticles.scrollTop = middleIndex * itemHeight;
    }
  }

  // ========================================
  // CHANGEMENT DE PROJET AU CLIC
  // ========================================
  document.addEventListener("click", (e) => {
    // Ignorer si on est en mode gravité (géré par Matter.js)
    if (isGravityMode) return;

    const clickedItem = e.target.closest(".sticky-item");

    if (clickedItem) {
      const projectId = clickedItem.getAttribute("data-project");
      if (projectId) {
        switchProject(projectId);
      }
    }
  });

  // Fonction pour changer de projet
  function switchProject(projectId) {
    const allProjects = document.querySelectorAll(".project-content");

    allProjects.forEach((project) => {
      project.classList.remove("active");
    });

    const selectedProject = document.querySelector(
      `.project-content[data-project="${projectId}"]`,
    );

    if (selectedProject) {
      setTimeout(() => {
        selectedProject.classList.add("active");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    } else {
      console.warn(`Projet "${projectId}" non trouvé`);
    }
  }

  // ========================================
  // INITIALISATION
  // ========================================
  const allProjects = document.querySelectorAll(".project-content");
  allProjects.forEach((project) => {
    project.classList.remove("active");
  });

  const defaultProject = document.querySelector(".project-content.active");
  if (!defaultProject) {
    const graphicProject = document.querySelector(
      '.project-content[data-project="graphic-1"]',
    );
    if (graphicProject) {
      graphicProject.classList.add("active");
    }
  }
});

// Footer Gravity Effect avec Matter.js-----------------------------------------------
window.addEventListener("load", function () {
  (function () {
    const {
      Engine,
      Render,
      Runner,
      World,
      Bodies,
      Mouse,
      MouseConstraint,
      Events,
    } = Matter;

    // Configuration
    const footerBottom = document.querySelector(".footer-bottom");
    if (!footerBottom) return;
    const buttons = footerBottom.querySelectorAll(".footer-box");

    // Créer le conteneur canvas
    const canvas = document.createElement("div");
    canvas.id = "physics-canvas";
    canvas.style.position = "absolute";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "auto"; // Changer en auto pour capturer les événements
    footerBottom.style.position = "relative";
    footerBottom.insertBefore(canvas, footerBottom.firstChild);

    // Créer le moteur physique
    const engine = Engine.create({
      gravity: { x: 0, y: 1 },
    });

    const render = Render.create({
      element: canvas,
      engine: engine,
      options: {
        width: footerBottom.offsetWidth,
        height: footerBottom.offsetHeight,
        wireframes: false,
        background: "transparent",
      },
    });

    // Ajouter le curseur grab au canvas
    canvas.style.cursor = "grab";

    // Stocker les informations des boutons
    const buttonBodies = [];
    const buttonElements = [];

    // Créer les corps physiques pour chaque bouton
    buttons.forEach((button) => {
      const rect = button.getBoundingClientRect();
      const parentRect = footerBottom.getBoundingClientRect();

      // Position aléatoire dans le footer
      const maxX = Math.max(0, parentRect.width - rect.width);
      const x = rect.width / 2 + Math.random() * maxX;
      const y = rect.height / 2 - Math.random() * 80;

      // Créer un corps rectangulaire
      const body = Bodies.rectangle(x, y, rect.width, rect.height, {
        restitution: 0.3,
        friction: 0.1,
        density: 0.002,
        render: {
          visible: false,
        },
      });

      World.add(engine.world, body);
      buttonBodies.push(body);
      buttonElements.push(button);

      // Rendre le bouton moins prioritaire pour les événements
      button.style.pointerEvents = "none"; // Les boutons ne captent plus les événements
      button.style.cursor = "grab";
    });

    // Créer les murs (limites de la boîte)
    function createWalls() {
      const width = footerBottom.offsetWidth;
      const height = footerBottom.offsetHeight;
      const thickness = 20;

      // Supprimer les anciens murs
      const oldWalls = engine.world.bodies.filter(
        (body) => body.isStatic && body.label === "wall",
      );
      World.remove(engine.world, oldWalls);

      // Sol
      const ground = Bodies.rectangle(
        width / 2,
        height + thickness / 2,
        width,
        thickness,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur gauche
      const leftWall = Bodies.rectangle(
        -thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur droit
      const rightWall = Bodies.rectangle(
        width + thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      World.add(engine.world, [ground, leftWall, rightWall]);
    }

    createWalls();

    // Système de drag pour les boutons avec lancer amélioré
    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
      },
    });

    World.add(engine.world, mouseConstraint);
    render.mouse = mouse;

    // Variables pour le système de lancer
    let lastMousePosition = { x: 0, y: 0 };
    let lastTime = Date.now();
    let velocityHistory = [];
    const velocityHistorySize = 8;
    let draggedButton = null;
    let isDragging = false;
    let mouseDownTime = 0;
    let mouseDownPosition = { x: 0, y: 0 };

    // Suivre la position de la souris pour calculer la vélocité
    Events.on(engine, "beforeUpdate", function () {
      const currentTime = Date.now();
      const deltaTime = (currentTime - lastTime) / 1000;

      if (mouseConstraint.body && deltaTime > 0) {
        const currentMousePosition = mouse.position;

        const instantVelocity = {
          x: (currentMousePosition.x - lastMousePosition.x) / deltaTime,
          y: (currentMousePosition.y - lastMousePosition.y) / deltaTime,
          time: currentTime,
        };

        velocityHistory.push(instantVelocity);
        if (velocityHistory.length > velocityHistorySize) {
          velocityHistory.shift();
        }

        lastMousePosition = { ...currentMousePosition };
      } else if (!mouseConstraint.body) {
        velocityHistory = [];
        lastMousePosition = { ...mouse.position };
      }

      lastTime = currentTime;
    });

    // Changer le curseur et visuels pendant le drag
    Events.on(mouseConstraint, "startdrag", function (event) {
      canvas.style.cursor = "grabbing";
      velocityHistory = [];
      lastMousePosition = { ...mouse.position };
      lastTime = Date.now();
      mouseDownTime = Date.now();
      mouseDownPosition = { ...mouse.position };
      isDragging = false;

      const draggedBodyIndex = buttonBodies.indexOf(event.body);
      if (draggedBodyIndex !== -1) {
        draggedButton = buttonElements[draggedBodyIndex];
        draggedButton.style.transition = "transform 0.1s ease";
        draggedButton.style.transform = `rotate(${event.body.angle}rad) scale(1.05)`;
      }
    });

    Events.on(mouseConstraint, "enddrag", function (event) {
      canvas.style.cursor = "grab";

      const dragDuration = Date.now() - mouseDownTime;
      const dragDistance = Math.sqrt(
        Math.pow(mouse.position.x - mouseDownPosition.x, 2) +
          Math.pow(mouse.position.y - mouseDownPosition.y, 2),
      );

      // Si le drag était court (< 200ms) et petit mouvement (< 10px), c'est un clic
      const isClick = dragDuration < 200 && dragDistance < 10;

      if (draggedButton) {
        draggedButton.style.transition = "none";

        // Si c'est un clic, déclencher l'action du bouton
        if (isClick) {
          draggedButton.click();
        }

        draggedButton = null;
      }

      // Calculer la vélocité moyenne pondérée seulement si ce n'est pas un clic
      if (!isClick && velocityHistory.length > 0 && event.body) {
        const now = Date.now();
        const recentVelocities = velocityHistory.filter(
          (v) => now - v.time < 200,
        );

        if (recentVelocities.length > 0) {
          let totalWeight = 0;
          const weightedVelocity = recentVelocities.reduce(
            (acc, vel, index) => {
              const weight = index + 1;
              totalWeight += weight;
              return {
                x: acc.x + vel.x * weight,
                y: acc.y + vel.y * weight,
              };
            },
            { x: 0, y: 0 },
          );

          weightedVelocity.x /= totalWeight;
          weightedVelocity.y /= totalWeight;

          const throwMultiplier = 0.015;
          const maxThrowSpeed = 20;

          let finalVelocityX = weightedVelocity.x * throwMultiplier;
          let finalVelocityY = weightedVelocity.y * throwMultiplier;

          const speed = Math.sqrt(
            finalVelocityX * finalVelocityX + finalVelocityY * finalVelocityY,
          );
          if (speed > maxThrowSpeed) {
            const scale = maxThrowSpeed / speed;
            finalVelocityX *= scale;
            finalVelocityY *= scale;
          }

          Matter.Body.setVelocity(event.body, {
            x: finalVelocityX,
            y: finalVelocityY,
          });

          if (speed > 10) {
            const angularVelocity =
              (finalVelocityX / 1000) * (Math.random() > 0.5 ? 1 : -1);
            Matter.Body.setAngularVelocity(event.body, angularVelocity);
          }
        }
      }

      velocityHistory = [];
    });

    // Synchroniser les positions des boutons HTML avec les corps physiques
    Events.on(engine, "afterUpdate", function () {
      buttonBodies.forEach((body, index) => {
        const button = buttonElements[index];
        button.style.position = "absolute";
        button.style.left = `${body.position.x - button.offsetWidth / 2}px`;
        button.style.top = `${body.position.y - button.offsetHeight / 2}px`;
        button.style.transform = `rotate(${body.angle}rad)`;
      });
    });

    // Lancer le moteur
    const runner = Runner.create();
    Runner.run(runner, engine);
    Render.run(render);

    // Gérer le redimensionnement de la fenêtre
    window.addEventListener("resize", function () {
      const width = footerBottom.offsetWidth;
      const height = footerBottom.offsetHeight;

      render.canvas.width = width;
      render.canvas.height = height;
      render.options.width = width;
      render.options.height = height;

      createWalls();
    });
  })();
});

// Main Gravity Effect avec Matter.js -------------------------------------------------------
window.addEventListener("load", function () {
  (function () {
    const {
      Engine,
      Render,
      Runner,
      World,
      Bodies,
      Mouse,
      MouseConstraint,
      Events,
    } = Matter;

    // Configuration
    const mainSection = document.querySelector(".main-btn");
    if (!mainSection) return;
    const buttons = mainSection.querySelectorAll("button");

    // Créer le conteneur canvas
    const canvas = document.createElement("div");
    canvas.id = "main-physics-canvas";
    canvas.style.position = "absolute";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "auto";
    mainSection.style.position = "relative";
    mainSection.style.width = "100vw";
    mainSection.style.height = "22vh";
    mainSection.style.overflow = "hidden";
    mainSection.insertBefore(canvas, mainSection.firstChild);

    // Créer le moteur physique
    const engine = Engine.create({
      gravity: { x: 0, y: 1 },
    });

    const render = Render.create({
      element: canvas,
      engine: engine,
      options: {
        width: mainSection.offsetWidth,
        height: mainSection.offsetHeight,
        wireframes: false,
        background: "transparent",
      },
    });

    // Ajouter le curseur grab au canvas
    canvas.style.cursor = "grab";

    // Stocker les informations des boutons
    const buttonBodies = [];
    const buttonElements = [];

    // Créer les corps physiques pour chaque bouton
    buttons.forEach((button) => {
      const rect = button.getBoundingClientRect();
      const parentRect = mainSection.getBoundingClientRect();

      // Position aléatoire dans le main
      const maxX = Math.max(0, parentRect.width - rect.width);
      const x = rect.width / 2 + Math.random() * maxX;
      const y = rect.height / 2 - Math.random() * 80;

      // Créer un corps rectangulaire
      const body = Bodies.rectangle(x, y, rect.width, rect.height, {
        restitution: 0.3,
        friction: 0.1,
        density: 0.002,
        render: {
          visible: false,
        },
      });

      World.add(engine.world, body);
      buttonBodies.push(body);
      buttonElements.push(button);

      // Rendre le bouton moins prioritaire pour les événements
      button.style.pointerEvents = "none";
      button.style.cursor = "grab";
    });

    // Créer les murs (limites de la boîte)
    function createWalls() {
      const width = mainSection.offsetWidth;
      const height = mainSection.offsetHeight;
      const thickness = 50;

      // Supprimer les anciens murs
      const oldWalls = engine.world.bodies.filter(
        (body) => body.isStatic && body.label === "wall",
      );
      World.remove(engine.world, oldWalls);

      // Sol
      const ground = Bodies.rectangle(
        width / 2,
        height + thickness / 2,
        width,
        thickness,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur gauche
      const leftWall = Bodies.rectangle(
        -thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur droit
      const rightWall = Bodies.rectangle(
        width + thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      World.add(engine.world, [ground, leftWall, rightWall]);
    }

    createWalls();

    // Système de drag pour les boutons avec lancer amélioré
    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
      },
    });

    World.add(engine.world, mouseConstraint);
    render.mouse = mouse;

    // Variables pour le système de lancer
    let lastMousePosition = { x: 0, y: 0 };
    let lastTime = Date.now();
    let velocityHistory = [];
    const velocityHistorySize = 8;
    let draggedButton = null;
    let isDragging = false;
    let mouseDownTime = 0;
    let mouseDownPosition = { x: 0, y: 0 };

    // Suivre la position de la souris pour calculer la vélocité
    Events.on(engine, "beforeUpdate", function () {
      const currentTime = Date.now();
      const deltaTime = (currentTime - lastTime) / 1000;

      if (mouseConstraint.body && deltaTime > 0) {
        const currentMousePosition = mouse.position;

        const instantVelocity = {
          x: (currentMousePosition.x - lastMousePosition.x) / deltaTime,
          y: (currentMousePosition.y - lastMousePosition.y) / deltaTime,
          time: currentTime,
        };

        velocityHistory.push(instantVelocity);
        if (velocityHistory.length > velocityHistorySize) {
          velocityHistory.shift();
        }

        lastMousePosition = { ...currentMousePosition };
      } else if (!mouseConstraint.body) {
        velocityHistory = [];
        lastMousePosition = { ...mouse.position };
      }

      lastTime = currentTime;
    });

    // Changer le curseur et visuels pendant le drag
    Events.on(mouseConstraint, "startdrag", function (event) {
      canvas.style.cursor = "grabbing";
      velocityHistory = [];
      lastMousePosition = { ...mouse.position };
      lastTime = Date.now();
      mouseDownTime = Date.now();
      mouseDownPosition = { ...mouse.position };
      isDragging = false;

      const draggedBodyIndex = buttonBodies.indexOf(event.body);
      if (draggedBodyIndex !== -1) {
        draggedButton = buttonElements[draggedBodyIndex];
        draggedButton.style.transition = "transform 0.1s ease";
        draggedButton.style.transform = `rotate(${event.body.angle}rad) scale(1.05)`;
      }
    });

    Events.on(mouseConstraint, "enddrag", function (event) {
      canvas.style.cursor = "grab";

      const dragDuration = Date.now() - mouseDownTime;
      const dragDistance = Math.sqrt(
        Math.pow(mouse.position.x - mouseDownPosition.x, 2) +
          Math.pow(mouse.position.y - mouseDownPosition.y, 2),
      );

      // Si le drag était court (< 200ms) et petit mouvement (< 10px), c'est un clic
      const isClick = dragDuration < 200 && dragDistance < 10;

      if (draggedButton) {
        draggedButton.style.transition = "none";

        // Si c'est un clic, déclencher l'action du bouton
        if (isClick) {
          draggedButton.click();
        }

        draggedButton = null;
      }

      // Calculer la vélocité moyenne pondérée seulement si ce n'est pas un clic
      if (!isClick && velocityHistory.length > 0 && event.body) {
        const now = Date.now();
        const recentVelocities = velocityHistory.filter(
          (v) => now - v.time < 200,
        );

        if (recentVelocities.length > 0) {
          let totalWeight = 0;
          const weightedVelocity = recentVelocities.reduce(
            (acc, vel, index) => {
              const weight = index + 1;
              totalWeight += weight;
              return {
                x: acc.x + vel.x * weight,
                y: acc.y + vel.y * weight,
              };
            },
            { x: 0, y: 0 },
          );

          weightedVelocity.x /= totalWeight;
          weightedVelocity.y /= totalWeight;

          const throwMultiplier = 0.015;
          const maxThrowSpeed = 20;

          let finalVelocityX = weightedVelocity.x * throwMultiplier;
          let finalVelocityY = weightedVelocity.y * throwMultiplier;

          const speed = Math.sqrt(
            finalVelocityX * finalVelocityX + finalVelocityY * finalVelocityY,
          );
          if (speed > maxThrowSpeed) {
            const scale = maxThrowSpeed / speed;
            finalVelocityX *= scale;
            finalVelocityY *= scale;
          }

          Matter.Body.setVelocity(event.body, {
            x: finalVelocityX,
            y: finalVelocityY,
          });

          if (speed > 10) {
            const angularVelocity =
              (finalVelocityX / 1000) * (Math.random() > 0.5 ? 1 : -1);
            Matter.Body.setAngularVelocity(event.body, angularVelocity);
          }
        }
      }

      velocityHistory = [];
    });

    // Synchroniser les positions des boutons HTML avec les corps physiques
    Events.on(engine, "afterUpdate", function () {
      buttonBodies.forEach((body, index) => {
        const button = buttonElements[index];
        button.style.position = "absolute";
        button.style.left = `${body.position.x - button.offsetWidth / 2}px`;
        button.style.top = `${body.position.y - button.offsetHeight / 2}px`;
        button.style.transform = `rotate(${body.angle}rad)`;
      });
    });

    // Lancer le moteur
    const runner = Runner.create();
    Runner.run(runner, engine);
    Render.run(render);

    // Gérer le redimensionnement de la fenêtre
    window.addEventListener("resize", function () {
      const width = mainSection.offsetWidth;
      const height = mainSection.offsetHeight;

      render.canvas.width = width;
      render.canvas.height = height;
      render.options.width = width;
      render.options.height = height;

      createWalls();
    });
  })();
});

// Header Gravity Effect avec Matter.js--------------------------------------------------------
window.addEventListener("load", function () {
  (function () {
    const {
      Engine,
      Render,
      Runner,
      World,
      Bodies,
      Mouse,
      MouseConstraint,
      Events,
    } = Matter;

    // Configuration
    const header = document.querySelector(".l-header");
    const buttons = header.querySelectorAll("button");

    // Créer le conteneur canvas
    const canvas = document.createElement("div");
    canvas.id = "header-physics-canvas";
    canvas.style.position = "absolute";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "auto";
    canvas.style.cursor = "grab";
    header.style.position = "relative";
    header.style.overflow = "hidden";
    header.insertBefore(canvas, header.firstChild);

    // Créer le moteur physique
    const engine = Engine.create({
      gravity: { x: 0, y: 1 },
    });

    const render = Render.create({
      element: canvas,
      engine: engine,
      options: {
        width: header.offsetWidth,
        height: header.offsetHeight,
        wireframes: false,
        background: "transparent",
      },
    });

    // Stocker les informations des boutons
    const buttonBodies = [];
    const buttonElements = [];

    // Créer les corps physiques pour chaque bouton
    buttons.forEach((button) => {
      const rect = button.getBoundingClientRect();
      const parentRect = header.getBoundingClientRect();

      // Position aléatoire dans le header
      const maxX = Math.max(0, parentRect.width - rect.width);
      const x = rect.width / 2 + Math.random() * maxX;
      const y = rect.height / 2 - Math.random() * 80;

      // Créer un corps rectangulaire
      const body = Bodies.rectangle(x, y, rect.width, rect.height, {
        restitution: 0.3,
        friction: 0.1,
        density: 0.002,
        render: {
          visible: false,
        },
      });

      World.add(engine.world, body);
      buttonBodies.push(body);
      buttonElements.push(button);

      // Rendre le bouton moins prioritaire pour les événements
      button.style.pointerEvents = "none";
      button.style.cursor = "grab";
    });

    // Créer les murs (limites de la boîte)
    function createWalls() {
      const width = header.offsetWidth;
      const height = header.offsetHeight;
      const thickness = 20;

      // Supprimer les anciens murs
      const oldWalls = engine.world.bodies.filter(
        (body) => body.isStatic && body.label === "wall",
      );
      World.remove(engine.world, oldWalls);

      // Sol
      const ground = Bodies.rectangle(
        width / 2,
        height + thickness / 2,
        width,
        thickness,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur gauche
      const leftWall = Bodies.rectangle(
        -thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      // Mur droit
      const rightWall = Bodies.rectangle(
        width + thickness / 2,
        height / 2,
        thickness,
        height * 2,
        {
          isStatic: true,
          label: "wall",
          render: { visible: false },
        },
      );

      World.add(engine.world, [ground, leftWall, rightWall]);
    }

    createWalls();

    // Système de drag pour les boutons avec lancer amélioré
    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
      },
    });

    World.add(engine.world, mouseConstraint);
    render.mouse = mouse;

    // Variables pour le système de lancer
    let lastMousePosition = { x: 0, y: 0 };
    let lastTime = Date.now();
    let velocityHistory = [];
    const velocityHistorySize = 8;
    let draggedButton = null;
    let isDragging = false;
    let mouseDownTime = 0;
    let mouseDownPosition = { x: 0, y: 0 };

    // Suivre la position de la souris pour calculer la vélocité
    Events.on(engine, "beforeUpdate", function () {
      const currentTime = Date.now();
      const deltaTime = (currentTime - lastTime) / 1000;

      if (mouseConstraint.body && deltaTime > 0) {
        const currentMousePosition = mouse.position;

        const instantVelocity = {
          x: (currentMousePosition.x - lastMousePosition.x) / deltaTime,
          y: (currentMousePosition.y - lastMousePosition.y) / deltaTime,
          time: currentTime,
        };

        velocityHistory.push(instantVelocity);
        if (velocityHistory.length > velocityHistorySize) {
          velocityHistory.shift();
        }

        lastMousePosition = { ...currentMousePosition };
      } else if (!mouseConstraint.body) {
        velocityHistory = [];
        lastMousePosition = { ...mouse.position };
      }

      lastTime = currentTime;
    });

    // Changer le curseur et visuels pendant le drag
    Events.on(mouseConstraint, "startdrag", function (event) {
      canvas.style.cursor = "grabbing";
      velocityHistory = [];
      lastMousePosition = { ...mouse.position };
      lastTime = Date.now();
      mouseDownTime = Date.now();
      mouseDownPosition = { ...mouse.position };
      isDragging = false;

      const draggedBodyIndex = buttonBodies.indexOf(event.body);
      if (draggedBodyIndex !== -1) {
        draggedButton = buttonElements[draggedBodyIndex];
        draggedButton.style.transition = "transform 0.1s ease";
        draggedButton.style.transform = `rotate(${event.body.angle}rad) scale(1.05)`;
      }
    });

    Events.on(mouseConstraint, "enddrag", function (event) {
      canvas.style.cursor = "grab";

      const dragDuration = Date.now() - mouseDownTime;
      const dragDistance = Math.sqrt(
        Math.pow(mouse.position.x - mouseDownPosition.x, 2) +
          Math.pow(mouse.position.y - mouseDownPosition.y, 2),
      );

      // Si le drag était court (< 200ms) et petit mouvement (< 10px), c'est un clic
      const isClick = dragDuration < 200 && dragDistance < 10;

      if (draggedButton) {
        draggedButton.style.transition = "none";

        // Si c'est un clic, déclencher l'action du bouton
        if (isClick) {
          // Trouver le lien parent et naviguer
          const parentLink = draggedButton.closest("a");
          if (parentLink && parentLink.href) {
            window.location.href = parentLink.href;
          }
        }

        draggedButton = null;
      }

      // Calculer la vélocité moyenne pondérée seulement si ce n'est pas un clic
      if (!isClick && velocityHistory.length > 0 && event.body) {
        const now = Date.now();
        const recentVelocities = velocityHistory.filter(
          (v) => now - v.time < 200,
        );

        if (recentVelocities.length > 0) {
          let totalWeight = 0;
          const weightedVelocity = recentVelocities.reduce(
            (acc, vel, index) => {
              const weight = index + 1;
              totalWeight += weight;
              return {
                x: acc.x + vel.x * weight,
                y: acc.y + vel.y * weight,
              };
            },
            { x: 0, y: 0 },
          );

          weightedVelocity.x /= totalWeight;
          weightedVelocity.y /= totalWeight;

          const throwMultiplier = 0.015;
          const maxThrowSpeed = 20;

          let finalVelocityX = weightedVelocity.x * throwMultiplier;
          let finalVelocityY = weightedVelocity.y * throwMultiplier;

          const speed = Math.sqrt(
            finalVelocityX * finalVelocityX + finalVelocityY * finalVelocityY,
          );
          if (speed > maxThrowSpeed) {
            const scale = maxThrowSpeed / speed;
            finalVelocityX *= scale;
            finalVelocityY *= scale;
          }

          Matter.Body.setVelocity(event.body, {
            x: finalVelocityX,
            y: finalVelocityY,
          });

          if (speed > 10) {
            const angularVelocity =
              (finalVelocityX / 1000) * (Math.random() > 0.5 ? 1 : -1);
            Matter.Body.setAngularVelocity(event.body, angularVelocity);
          }
        }
      }

      velocityHistory = [];
    });

    // Synchroniser les positions des boutons HTML avec les corps physiques
    Events.on(engine, "afterUpdate", function () {
      buttonBodies.forEach((body, index) => {
        const button = buttonElements[index];
        button.style.position = "absolute";
        button.style.left = `${body.position.x - button.offsetWidth / 2}px`;
        button.style.top = `${body.position.y - button.offsetHeight / 2}px`;
        button.style.transform = `rotate(${body.angle}rad)`;
      });
    });

    // Lancer le moteur
    const runner = Runner.create();
    Runner.run(runner, engine);
    Render.run(render);

    // Gérer le redimensionnement de la fenêtre
    window.addEventListener("resize", function () {
      const width = header.offsetWidth;
      const height = header.offsetHeight;

      render.canvas.width = width;
      render.canvas.height = height;
      render.options.width = width;
      render.options.height = height;

      createWalls();
    });
  })();
});

// ========================================
// TRADUCTION FR / EN
// ========================================
var french = document.getElementById("fr_click"),
  english = document.getElementById("en_click"),
  fr_txt = document.querySelectorAll("#fr"),
  en_txt = document.querySelectorAll("#en"),
  nb_fr = fr_txt.length,
  nb_en = en_txt.length;

function langue(langueOn, langueOff) {
  if (!langueOn.classList.contains("current_lang")) {
    langueOn.classList.toggle("current_lang");
    langueOff.classList.toggle("current_lang");
  }
  if (langueOn.innerHTML == "Fr") {
    afficher(fr_txt, nb_fr);
    cacher(en_txt, nb_en);
    document.body.classList.remove("lang-en");
    localStorage.setItem("lang", "fr");
  } else if (langueOn.innerHTML == "En") {
    afficher(en_txt, nb_en);
    cacher(fr_txt, nb_fr);
    document.body.classList.add("lang-en");
    localStorage.setItem("lang", "en");
  }
}

function afficher(txt, nb) {
  for (var i = 0; i < nb; i++) {
    txt[i].style.display = "block";
  }
}
function cacher(txt, nb) {
  for (var i = 0; i < nb; i++) {
    txt[i].style.display = "none";
  }
}

french.addEventListener(
  "click",
  function () {
    langue(french, english);
  },
  false,
);
english.addEventListener(
  "click",
  function () {
    langue(english, french);
  },
  false,
);

function init() {
  const saved = localStorage.getItem("lang");
  if (saved === "en") {
    langue(english, french);
  } else {
    langue(french, english);
  }
}
init();

// ========================================
// DRAG VERTICAL FR / EN (sans ficelle)
// ========================================
let frOff = 0,
  enOff = 0;
let frVel = 0,
  enVel = 0;

const SPRING = 0.09;
const DAMP = 0.72;

function physics() {
  frVel += (0 - frOff) * SPRING;
  frVel *= DAMP;
  frOff += frVel;
  french.style.transform = `translateY(${frOff}px)`;

  enVel += (0 - enOff) * SPRING;
  enVel *= DAMP;
  enOff += enVel;
  english.style.transform = `translateY(${enOff}px)`;

  requestAnimationFrame(physics);
}

french.style.cursor = "pointer";
english.style.cursor = "pointer";

physics();
